import React from 'react';
import { useIntl } from 'react-intl';
import { siteConfig } from '../../config/siteConfig';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PremiumBadge } from '../../components/Icons';
import Button from '../../components/Button/Button';

const Container = styled.div`
  max-width: 480px;
  margin: 64px auto 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  background: var(--surface);
  border: solid 1px var(--border-light);
  border-radius: 4px;
  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.06);
`;

const Title = styled.h1`
  font-size: 1.2rem;
  margin-bottom: 16px;
  font-weight: 600;
  color: var(--text);
`;

const Text = styled.p`
  color: var(--text-muted);
  font-size: 1rem;
  text-align: left;
  width: 100%;
`;

const HomeLink = styled(Link)`
  text-decoration: none;
  text-align: center;
  color: #fff;
`;

const SubscriptionSuccess: React.FC = () => {
  const intl = useIntl();
  return (
    <Container>
      <PremiumBadge height="144" width="144" />
      <Title>{intl.formatMessage({ id: 'subscriptionSuccess.title' })}</Title>
      <Text>{intl.formatMessage({ id: 'subscriptionSuccess.text1' })}</Text>
      <Text>
        {intl.formatMessage(
          { id: 'subscriptionSuccess.text2' },
          { contactEmail: siteConfig.contactEmail }
        )}
      </Text>
      <Text>
        {intl.formatMessage(
          { id: 'subscriptionSuccess.text3' },
          { appName: siteConfig.appName }
        )}
      </Text>
      <Text>{intl.formatMessage({ id: 'subscriptionSuccess.text4' })}</Text>
      <Button>
        <HomeLink to="/">
          {intl.formatMessage({ id: 'subscriptionSuccess.goHome' })}
        </HomeLink>
      </Button>
    </Container>
  );
};

export default SubscriptionSuccess;
